import axiosInstance from './axiosInstance';

const planService = {
  /**
   * Get all plans
   */
  getAllPlans: async () => {
    try {
      const response = await axiosInstance.get('/admin/organizations/plans/all');
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default planService;
